import { Button } from '@/components/ui/Button';
import { cn } from '@/lib/utils';

import { FEED_PILL_CLASS } from './feedStyles';

import type { FeedPrimaryPress, FeedRowView } from './feedRowView';

type FeedRunningPillProps = {
  pill: NonNullable<FeedRowView['pill']>;
  // A parent's current step is the parent's status, quieter than the parent's own buttons
  quiet?: boolean;
  onPress: (press: FeedPrimaryPress) => void;
};

// The row's button while its run is going
export const FeedRunningPill = ({
  pill,
  quiet = false,
  onPress,
}: FeedRunningPillProps) => (
  <Button
    variant="outline"
    size="xs"
    isLoading
    loadingText={pill.runningLabel}
    className={cn(
      FEED_PILL_CLASS,
      'disabled:opacity-100 aria-busy:border-transparent',
      quiet
        ? 'aria-busy:bg-secondary aria-busy:text-foreground-subtle'
        : 'aria-busy:bg-foreground-subtle aria-busy:text-background'
    )}
    onClick={() => onPress(pill.press)}
  >
    {pill.label}
  </Button>
);
